import { Helper } from "@/mixin/helper"

export default {
  mixins: [Helper],
  computed: {
    fields() {
      return [
        {
          label: this.$t('salesOrder.field.salesOrderNumber'),
          key: 'number',
          isRedirectable: true,
          hasOpenNewTab: true,
          isSticky: true,
          isLocked: true,
          isSortable: true,
          thAttr: {
            style: 'left:49.5px;position:sticky;z-index:1;min-width:180px;max-width:180px',
          },
          tdAttr: {
            style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;',
          },
        },
        {
          label: 'Status',
          key: 'status.name',
          isSticky: true,
          isLocked: true,
          isSortable: true,
          thAttr: {
            style: 'left:229.5px;position:sticky;z-index:1;',
          },
          tdAttr: {
            style: 'left:229.5px;position:sticky;',
          },
        },
        {
          label: this.$t('salesOrder.field.salesName'),
          key: 'sales_name',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.customerName'),
          key: 'customer_name',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.referenceNumber'),
          key: 'reference_number',
          isSortable: true,
        },
        {
          label: this.$t('global.field.createdDate'),
          key: 'created_on',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.targetPickedOn'),
          key: 'target.picked_on',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.targetDeliveredOn'),
          key: 'target.delivered_on',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.senderName'),
          key: 'sender.name',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.senderPhoneNumber'),
          key: 'sender.phone_number',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.recipientName'),
          key: 'recipient.name',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.recipientPhoneNumber'),
          key: 'recipient.phone_number',
          isSortable: true,
        },
        {
          label: this.$t('salesOrder.field.totalWeight'),
          key: 'total_weight',
          isSortable: true,
          formatter: (value) => value !== null ? `${this.localeThousandFormat(value)} kg` : "",
        },
        {
          label: this.$t('salesOrder.field.totalVolume'),
          key: 'total_volume',
          isSortable: true,
          formatter: (value) => value !== null ? `${this.localeThousandFormat(value)} cbm` : "",
        },
        {
          label: this.$t('salesOrder.field.totalPrice'),
          key: 'total_price',
          isSortable: true,
          thStyle: "min-width: 150px",
          formatter: (value) => value !== null ? `Rp ${this.localeThousandFormat(value)}`: ""
        },
        {
          label: this.$t('salesOrder.field.locations'),
          key: 'locations',
          isSortable: true,
          formatter: (value) => value.length > 0 ? value.join(', ') : '-'
        }
      ]
    }
  }
}